if (!window.plssCopyInstalled) {
  window.plssCopyInstalled = true;
  document.addEventListener('click', async function(event) {
    const button = event.target.closest('[data-plss-copy]');
    if (!button) return;
    const container = button.closest('[data-plss-token]');
    const address = container.querySelector('[data-plss-address]');
    const status = container.querySelector('[data-plss-status]');
    try {
      if (!navigator.clipboard) throw new Error('Clipboard unavailable');
      await navigator.clipboard.writeText(address.textContent.trim());
      status.textContent = button.dataset.success;
    } catch (error) {
      const range = document.createRange();
      range.selectNodeContents(address);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      status.textContent = button.dataset.failure;
    }
  });
}